/*	MARK: Ai5 Machine Data models
	============================================
 */
/** Imports **/
import { inject, PLATFORM } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DataService, Request } from '../services/data-service';
import { Api } from '../services/api';
import { FormatBytes } from './machine-schemas';


@inject(DataService, Api, Router)
export class MachineInsights {
	/** Components methods **/
	constructor(ds,api,router){
		this.ds 	= ds;
		this.router = router;
		this.api	= api;
		// Variables
		this.formatBytes = FormatBytes // constant
	}

	activate(params){ this.id = params.id }
	
	attached(){
		window.setTimeout( () => { this.init() }, 300);
	}

	init(){
		let machine = this.ds.app_data.machine;
		if(machine){ this.machine = machine;}
		else{
			// Get remote machine data
			this.getMachine(this.id).then(response => {
				this.handleMachineResponse(response);
			});
		}
	}

	/** Remote api calls **/
	getMachine(id){
		// Request
		let request 	= new Request("/api/v2/machines/id?", "GET");
		let params  	= new URLSearchParams({ id:id });
		request.url 	= request.url + params;
		// Perform remote call
		return this.api.get(request);
	}

	handleMachineResponse(response){
		let status = response.status;
		if(status === 200){
			let machine  = response.data;
			this.machine = machine
			this.ds.app_data.machine = machine;
		};
	}
}

